import {User} from "./user";
import {Project} from "./project";
import {Company} from "./company";
import {FormFile} from "./material";
import {Floor} from "./floor";
import {Unit} from "./unit";
import {Room} from "./room";
import {Area} from "./area";
import {Comment} from "./comment";
import {HistoryItem} from "./historyItem";
import {Trade} from "./trade";

export class Task {
  id: number;
  name: string;
  publicId: string;
  member: User;
  description: string;
  priority: TaskPriority;
  status: TaskStatus = TaskStatus.TO_DO;
  dueDate: number;
  files: FormFile[] = [];
  hasAttachments: boolean;
  version: number;
  company: Company;
  project: Project;
  creator: User;
  trade: Trade;

  type: TaskType;
  floor: Floor;
  unit: Unit;
  room: Room;
  roomArea: Area;

  floorName: string;
  unitName: string;
  roomName: string;
  roomAreaName: string;

  comments: Comment[] = [];
  history: HistoryItem[] = [];
  attachmentsAmount: number;

  userHasAccess: boolean;
  userCanEdit: boolean;

  taskLink: string;

  parentDueDate: string;
}

export class TaskComment {
  id: number;
  timestamp: number;
  author: User;
  html: any;
  safeHtml: any;
  files: FormFile[] = [];
}

// export class TaskFile {
//   id: number;
//   name: string;
//   sizeBytes: number;
//   fileUrl: string;
//   fileToSave: any;
//   progress: number;
//   timeLeft: number;
//   imgSrc: string;
// }

export enum TaskStatus {
  READY = "READY",
  TO_DO = "TO_DO",
  IN_PROGRESS = "IN_PROGRESS",
  DONE = "DONE"
}

export enum TaskPriority {
  NO_PRIORITY = "NO_PRIORITY",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}

export enum TaskType {
  PROJECT_TASK = "PROJECT_TASK",
  FLOOR_TASK = "FLOOR_TASK",
  UNIT_TASK = "UNIT_TASK",
  ROOM_TASK = "ROOM_TASK",
  AREA_TASK = "AREA_TASK",
  GENERAL_TASK = "GENERAL_TASK",
}

export enum TaskDueDate {
  PAST_DUE = "PAST_DUE",
  DUE_TODAY = "DUE_TODAY",
  DUE_THIS_WEEK = "DUE_THIS_WEEK",
  DUE_THIS_MONTH = "DUE_THIS_MONTH",
}

